import * as React from "react";

const SignIn: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="18px"
            height="18px"
            viewBox="0 0 18 18"
            version="1.1"
        >
            <title>Sign In Icon@1x</title>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="#000" fillRule="evenodd">
                <g id="Group-3" transform="translate(0.000000, 11.012653)">
                    <path
                        d="M16.460249,5.528372 L1.371559,5.528372 L1.371559,4.728202 C1.371559,2.837602 3.138879,1.413212 5.029709,1.413212 L12.802789,1.413212 C14.693159,1.413212 16.460249,2.837602 16.460249,4.728202 L16.460249,5.528372 Z M12.802789,0.041722 L5.029709,0.041722 C2.382409,0.041722 6.9e-05,2.081132 6.9e-05,4.728202 L6.9e-05,6.214002 C6.9e-05,6.592812 0.307119,6.900092 0.685929,6.900092 L17.145879,6.900092 C17.525149,6.900092 17.831969,6.592812 17.831969,6.214002 L17.831969,4.728202 C17.831969,2.081132 15.449399,0.041722 12.802789,0.041722 L12.802789,0.041722 Z"
                        id="Fill-1"
                        mask="url(#mask-3)"
                    />
                </g>
                <g id="Group-6" transform="translate(3.910000, 0.202653)">
                    <path
                        d="M5.006065,1.327514 C3.646075,1.327514 2.440645,2.090194 1.860355,3.318164 L1.859665,3.319314 C1.634955,3.784374 1.521105,4.286694 1.521105,4.812704 C1.521105,5.338714 1.634265,5.839884 1.857825,6.301954 C2.439955,7.533604 3.646075,8.297894 5.006065,8.297894 C6.365825,8.297894 7.571025,7.535214 8.151545,6.307244 C8.377175,5.841264 8.491255,5.338714 8.491255,4.812704 C8.491255,4.286694 8.377865,3.785754 8.154305,3.323684 C7.571715,2.091804 6.365825,1.327514 5.006065,1.327514 M5.006065,9.598084 C3.137775,9.598084 1.481775,8.549744 0.684365,6.862464 C0.376855,6.226284 0.220685,5.536054 0.220685,4.812704 C0.220685,4.089124 0.377545,3.397744 0.687125,2.757424 C1.482465,1.073824 3.137545,0.027324 5.006065,0.027324 C6.874125,0.027324 8.529895,1.075434 9.327305,2.762714 C9.635275,3.399584 9.791675,4.089814 9.791675,4.812704 C9.791675,5.535594 9.634585,6.227204 9.324545,6.867984 C8.529205,8.551584 6.874125,9.598084 5.006065,9.598084"
                        id="Fill-4"
                        mask="url(#mask-5)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(SignIn);
